module.exports = __webpack_public_path__ + "static/flow-ea8e62deefc1a9e4849e8ad3311cec60.jpg";